import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import {
    Box,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Button,
    Checkbox
} from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import PopUp from '../../../../commonModules/interface/PopUp';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import { pink } from '@material-ui/core/colors';
import ProgressCircle from '../../../../commonModules/interface/ProgressCircle';
import { ListLayout, TableLayout } from '../containers/Layout';
import Currency from '../../../../commonModules/Currency';
import mime from 'mime';
import { toast } from 'react-toastify';

import { CloudDownloadRounded, CloseRounded, CheckCircleOutlineRounded, HighlightOffRounded, IndeterminateCheckBoxOutlined } from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import DeleteDialog from '../../../../commonModules/interface/DeleteDialog';
import LinkIncome from '../../Repayment/LinkIncome';

class SingleSaleCredits extends Component {
    state = {
        // Dépointage : le paiement visé, puis le mot de passe une fois le récapitulatif validé.
        unlinkCredit: null,
        unlinkConfirmed: false,
        historySale: [],
        history: [],
        clients: [],
        currentYear: "2021",
        checkedCredits: [],
        openLink: false,
        incomeID: "",
        parts: {},
        max: {},
    }
    componentDidMount = () => {
        if ( isEmpty(this.props.SALE_CREDITS) ){
            this.props.fetchSaleCredits()
        }
    }
    filterList = () => {
        const { SALE_CREDITS } = this.props;
        console.log("[DEBUG],filterList",SALE_CREDITS)
        let list = !isEmpty(SALE_CREDITS) ? Object.values(SALE_CREDITS).filter( item => item.sale_id === this.props.sale.id) : []
        return list
    }
    handleToggleCredit = (creditID) => {
        this.setState((prevState) => {
            const checked = prevState.checkedCredits.includes(creditID)
                ? prevState.checkedCredits.filter(id => id !== creditID)
                : [...prevState.checkedCredits, creditID];
            return { checkedCredits: checked };
        });
    }
    getSelectedCredits = (list) => {
        const { checkedCredits } = this.state;
        return list.filter(item => checkedCredits.includes(item.id));
    }
    getAmountAvailableForCredit = (item) => {
        const amount = parseFloat(item.amount || 0) || 0;
        const amountLinked = parseFloat(item.amount_linked || 0) || 0;
        if (amountLinked === 0 && item.income_id) return 0;
        return Math.max(0, amount - amountLinked);
    }
    getSelectedTotal = (list) => {
        const { parts } = this.state;
        const selected = this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0);
        if (Object.keys(parts).length > 0) {
            return selected.reduce((sum, item) => sum + (parseFloat(parts[item.id]) || 0), 0);
        }
        return selected.reduce((sum, item) => sum + this.getAmountAvailableForCredit(item), 0);
    }
    getLiveSale = () => {
        const { sale, SALES } = this.props;
        if (!sale || !sale.id) {
            return sale || {};
        }
        return (SALES && SALES[sale.id]) || sale;
    }
    isCreditFullyLinked = (item) => {
        const amount = parseFloat(item.amount || 0) || 0;
        const amountLinked = parseFloat(item.amount_linked || 0) || 0;
        if (amountLinked >= amount) return true;
        if (amountLinked === 0 && (item.income_id || item.fact_id_5000)) return true;
        return false;
    }
    isCreditPartiallyLinked = (item) => {
        const amount = parseFloat(item.amount || 0) || 0;
        const amountLinked = parseFloat(item.amount_linked || 0) || 0;
        return amountLinked > 0 && amountLinked < amount;
    }
    handleOpenLink = () => {
        const list = this.filterList();
        const selected = this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0);
        const parts = {};
        const max = {};
        selected.forEach((item) => {
            const available = this.getAmountAvailableForCredit(item);
            parts[item.id] = available;
            max[item.id] = available;
        });
        this.setState({ openLink: true, parts, max });
    }
    handlePartChange = (e, creditID) => {
        const value = parseFloat(e.target.value);
        const { parts, max } = this.state;
        const capped = Math.min(Math.max(0, isNaN(value) ? 0 : value), max[creditID] || 0);
        this.setState({ parts: { ...parts, [creditID]: capped } });
    }
    removeSelectedCredit = (creditID) => {
        this.setState((prevState) => {
            const checkedCredits = prevState.checkedCredits.filter(id => id !== creditID);
            const parts = { ...prevState.parts };
            const max = { ...prevState.max };
            delete parts[creditID];
            delete max[creditID];
            return { checkedCredits, parts, max };
        });
    }
    handleSubmitUnLink = async (password) => {
        const { unlinkCredit } = this.state;
        const { unLinkCreditPaymentsTo5000 } = this.props;
        if (!unlinkCredit) return;
        if (typeof unLinkCreditPaymentsTo5000 !== "function") {
            toast.error("Le dépointage n'est pas disponible sur cet écran.");
            return;
        }

        const amount = parseFloat(unlinkCredit.amount_linked || 0) || 0;
        const issue = await unLinkCreditPaymentsTo5000({
            income_id: unlinkCredit.income_id || unlinkCredit.fact_id_5000,
            id_list: { [unlinkCredit.id]: amount },
            total: amount,
            password,
        });

        this.setState({ unlinkCredit: null, unlinkConfirmed: false });
        if (issue && issue.ok === false) {
            toast.error(issue.error || "Le dépointage n'a pas abouti.");
            return;
        }
        toast.info("Opération enregistrée avec succès");
    };

    handleSubmitLink = async () => {
        const { linkCreditPaymentsTo5000 } = this.props;
        const sale = this.getLiveSale();
        const list = this.filterList();
        const selected = this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0);
        const { parts } = this.state;
        const id_list = {};
        let totalSelected = 0;
        selected.forEach((c) => {
            const amt = parseFloat(parts[c.id]) || 0;
            if (amt > 0) {
                id_list[c.id] = amt;
                totalSelected += amt;
            }
        });

        if (!sale || !sale.id) {
            toast.error("Vente introuvable");
            return;
        }
        if (totalSelected <= 0 || Object.keys(id_list).length === 0) {
            toast.error("Sélectionnez au moins un montant à pointer");
            return;
        }
        if (typeof linkCreditPaymentsTo5000 !== "function") {
            toast.error("Action de pointage indisponible");
            return;
        }

        const data = {
            income_id: this.state.incomeID,
            id_list,
            total: totalSelected
        };

        await linkCreditPaymentsTo5000(data);
        if (this.props.STATE && this.props.STATE.sales && this.props.STATE.sales.error) {
            toast.error(this.props.STATE.sales.error);
        } else {
            toast.info("Paiement(s) pointé(s) avec succès");
            this.setState({ openLink: false, incomeID: "", checkedCredits: [], parts: {}, max: {} });
        }
    }

    render() {
        const { client } = this.props;
        const sale = this.getLiveSale();
        let list = this.filterList()
        let total = 0
        list.forEach(item => total += item.amount)
        // Dénominateur = montant TTC de la vente (aligné sur la colonne "Payé / TTC"
        // du tableau des ventes, cf. ListTransferSale.jsx). On retombe sur total_price
        // si le TTC est absent (enregistrements legacy) pour éviter une division par 0.
        const totalToPay = parseFloat(sale.total_price_TTC ?? sale.total_price ?? 0);
        const selectedCredits = this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0);
        const selectedTotal = this.getSelectedTotal(list);
        const hasAlreadyLinkedPayments = list.some(item => this.isCreditFullyLinked(item) || this.isCreditPartiallyLinked(item));
        console.log({list});

        console.log(this.state, this.props);
        return (
            <>
            {this.state.openLink &&
                <LinkIncome
                    title="Pointer les paiements crédit"
                    handleClose={() => this.setState({ openLink: false, incomeID: "" })}
                    handleChange={(e) => this.setState({ incomeID: e.target.value })}
                    incomeID={this.state.incomeID}
                    getIncomeInfo={this.props.getIncomeInfo}
                    handleSubmitLink={this.handleSubmitLink}
                    totalPay={selectedTotal}
                >
                    {selectedCredits.map(item => (
                        <ListItem key={item.id}>
                            <ListItemAvatar
                                onClick={() => this.removeSelectedCredit(item.id)}
                                style={{ cursor: "pointer" }}
                            >
                                <CloseRounded color="error" />
                            </ListItemAvatar>
                            <ListItemText
                                primary={item.ref}
                                secondary={new Date(item.date).toLocaleString("fr-FR")}
                            />
                            <ListItemSecondaryAction>
                                <InputText
                                    required
                                    label="Montant"
                                    type="number"
                                    name="amount"
                                    value={(this.state.parts || {})[item.id] ?? ""}
                                    onChange={(e) => this.handlePartChange(e, item.id)}
                                    helperText={`Max: ${(this.state.max || {})[item.id] ?? 0} / ${item.amount ?? 0}`}
                                    size="small"
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </LinkIncome>
            }
            <PopUp
                title={`${sale.nature} n°${sale.id}`}
                close={this.props.closePopUp}
            >
                {/* <SwipeableTabs
                    labels={["Ventes", "Clients"]}
                    default="Ventes" 
                > */}
                    <Grid container spacing={1} style={{ textAlign: "center"}}>
                        <Grid item xs={12} md={8} >
                            <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Typography variant="h6">Liste des paiements à Crédit</Typography>
                                {this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0).length > 0 &&
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={this.handleOpenLink}
                                    >
                                        Pointer {this.getSelectedCredits(list).filter(item => this.getAmountAvailableForCredit(item) > 0).length} paiement(s)
                                    </Button>
                                }
                            </Box>
                            {hasAlreadyLinkedPayments &&
                                <Box pb={1}>
                                    <Typography variant="body2" color="secondary">
                                        Certains paiements sont déjà pointés.
                                    </Typography>
                                </Box>
                            }
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox"></TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Ref</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Documents</TableCell>
                                        <TableCell>Pointage</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { list.map( item => 
                                    <TableRow key={item.id}>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                checked={this.state.checkedCredits.includes(item.id)}
                                                onChange={() => this.handleToggleCredit(item.id)}
                                                disabled={this.isCreditFullyLinked(item)}
                                                color="primary"
                                            />
                                        </TableCell>
                                        <TableCell>{new Date(item.date).toLocaleString("fr-FR")}</TableCell>
                                        <TableCell>{item.ref}</TableCell>
                                        <TableCell><Currency value={item.amount} /></TableCell>
                                        <TableCell>
                                            {!isEmpty(item.credit_files) &&
                                                <a href={`/stocks/photos/${item.credit_files[0].filename}`} 
                                                    download={`${client.client_lastname}_${item.ref}.${ mime.getExtension(item.credit_files[0].filetype) || "pdf"}`}
                                                >
                                                    <IconButton color="secondary" >
                                                        <CloudDownloadRounded />
                                                    </IconButton>      
                                                </a>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {this.isCreditFullyLinked(item) ? (
                                                <CheckCircleOutlineRounded style={{ color: "#2e7d32" }} titleAccess="Pointé" />
                                            ) : this.isCreditPartiallyLinked(item) ? (
                                                <Typography variant="body2" color="secondary" titleAccess="Partiellement pointé">
                                                    <Currency value={item.amount_linked} /> / <Currency value={item.amount} />
                                                </Typography>
                                            ) : (
                                                <HighlightOffRounded style={{ color: "#d32f2f" }} titleAccess="Non pointé" />
                                            )}
                                            {(item.income_id || item.fact_id_5000) &&
                                                <IconButton
                                                    size="small"
                                                    title="Dépointer ce paiement"
                                                    onClick={() => this.setState({ unlinkCredit: item, unlinkConfirmed: false })}
                                                >
                                                    <IndeterminateCheckBoxOutlined style={{ color: red[300] }} fontSize="small" />
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6">Total des paiements</Typography>
                            <Box p={1}>
                                <ProgressCircle
                                    color={pink[200]}
                                    spent={total}
                                    max={totalToPay}
                                    value={totalToPay ? total*100/totalToPay : 0}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                {/* </SwipeableTabs> */}
            </PopUp>
            {this.state.unlinkCredit && !this.state.unlinkConfirmed &&
                <PopUp
                    close={() => this.setState({ unlinkCredit: null })}
                    submitAction={() => this.setState({ unlinkConfirmed: true })}
                    submitTitle="Continuer"
                    maxWidth="xs"
                    title="Dépointer ce paiement"
                >
                    <Box p={1}>
                        <Typography variant="body2" gutterBottom>
                            Recette 5000 : <strong>{this.state.unlinkCredit.income_id || this.state.unlinkCredit.fact_id_5000}</strong>
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Montant rattaché : <strong><Currency value={this.state.unlinkCredit.amount_linked} /></strong>
                        </Typography>
                        <Typography variant="body2">
                            Ce montant sera rendu à la recette 5000. Les autres paiements rattachés à la
                            même recette ne sont pas touchés.
                        </Typography>
                    </Box>
                </PopUp>
            }
            {this.state.unlinkCredit && this.state.unlinkConfirmed &&
                <DeleteDialog
                    open={true}
                    title="le pointage de ce paiement"
                    close={() => this.setState({ unlinkCredit: null, unlinkConfirmed: false })}
                    handleSubmit={this.handleSubmitUnLink}
                />
            }
            </>
        );
    }
}

export default SingleSaleCredits;
